<template>

    <div id="signup" class="container-fluid" style="background-color: #eeeeee;">
        <div class="row">

            <div class="col-md-12">
                <section class="top-cat">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 v-if="lang === 'ar'">سجل بطاقة وفر</h1>
                                <h1 v-else>REGISTER YOUR WAFFIR CARD</h1>
                                <p v-if="lang === 'ar'"><span>ابدأ التوفير الآن!</span></p>
                                <p v-else>START SAVING MONEY!</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <!--================================================================================================================-->
            <!--================================================================================================================-->
            <!--================================================================================================================-->

            <div v-bind:class="{ 'rtl': rtl}" class="container"  v-if="stepNo == 1 || !stepNo">
                <div class="row">
                    <div class="col activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="credit-card" scale="2"></icon> &nbsp; إدخال رقم هاتفك</h5>
                        <h5 v-else><icon name="credit-card" scale="2"></icon> &nbsp; Register your card details</h5>
                    </div>
                </div>
                <div class="row shadows">
                    <div class="col" style="background-color: white; border: solid 1px darkgrey;">

                        <div class="signup-form">
                            <form @submit.prevent="checkCard">
<!--                                <div class="form-group">-->

<!--                                    <h5 v-if="lang === 'ar'"><br/><icon name="tag" scale="2"></icon> &nbsp; يرجى إدخال رقم بطاقة وافر الخاص بك</h5>-->
<!--                                    <h5 v-else><br/><icon name="tag" scale="2"></icon> &nbsp; Please enter your Waffir card number</h5>-->
<!--                                    <input-->
<!--                                            :class="{'is-danger-input': form.errors.has('name')}"-->
<!--                                            v-model="form.card"-->
<!--                                            name="name"-->
<!--                                            type="text"-->
<!--                                            placeholder="Waffir Number #"-->
<!--                                            id="name">-->
<!--                                    <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>-->
<!--                                </div>-->

                                <div class="form-group">

                                    <h5 v-if="lang === 'ar'"><br/><icon name="mobile" scale="2"></icon> &nbsp; الرجاء إدخال رقم هاتفك المحمول</h5>
                                    <h5 v-else><br/><icon name="mobile" scale="2"></icon> &nbsp; Please enter your mobile number for OTP</h5>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="input">
                                                <multiselect
                                                    v-model="multiSelect.countryCode"
                                                    @input="onSelectCountryCodes"
                                                    :options="countryCodes"
                                                    placeholder="Country Code - إن ال رمز البلد"
                                                    label="name" track-by="id">
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <input
                                                :class="{'is-danger-input': form.errors.has('company')}"
                                                name="mobile"
                                                type="text"
                                                :placeholder="mobilePlaceholder"
                                                id="company"
                                                v-model="form.mobile">
                                        </div>
                                    </div>


                                    <span class="help is-danger" v-if="form.errors.has('company')" v-text="form.errors.get('mobile')"></span>
                                </div>

                                <b-alert v-if="form.errors.error.title || form.errors.error.message" show variant="warning">
                    <span class="help is-danger">
                        <icon name="warning" scale="0.9"></icon> &nbsp; &nbsp;
                        <strong v-if="form.errors.error.title">{{form.errors.error.title}}: <br/></strong>
                        {{form.errors.error.message}}
                    </span>
                                </b-alert>

                                <div class="submit">
                                    <br/>
                                    <div v-if="lang === 'ar'" class="col"><button type="submit" class="buttonx"><icon name="envelope" scale="2"></icon> &nbsp; بدء التسجيل</button></div>
                                    <div v-else class="col"><button type="submit" class="buttonx"><icon name="envelope" scale="2"></icon> &nbsp; Verify Mobile Number</button></div>
                                    <br/>
                                    <h5 v-if="lang === 'ar'">المستخدمين المسجلين ، يرجى <router-link to="/login">الضغط هنا</router-link> لتسجيل الدخول</h5>
                                    <h5 v-else>Registered users, please <router-link to="/login">Click Here</router-link> to login to your account</h5>

                                    <br/>&nbsp;
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 inactiveTab">
                        <h5 v-if="lang === 'ar'"><icon name="mobile" scale="2"></icon> &nbsp;تحقق من رقم الجوال</h5>
                        <h5 v-else><icon name="mobile" scale="2"></icon> &nbsp; Verify your mobile number</h5>
                    </div>
                    <div class="col-md-12 inactiveTab">
                        <h5 v-if="lang === 'ar'"><icon name="user" scale="2"></icon> &nbsp; التفاصيل الشخصية والتسجيل</h5>
                        <h5 v-else><icon name="user" scale="2"></icon> &nbsp; Personal Details and Register</h5>
                    </div>
                </div>
            </div>

            <!--================================================================================================================-->
            <!--================================================================================================================-->
            <!--================================================================================================================-->

            <div class="container"  v-if="stepNo == 2">
                <div class="row">
                    <div class="col activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="credit-card" scale="2"></icon> &nbsp; أدخل تفاصيل البطاقة</h5>
                        <h5 v-else><icon name="credit-card" scale="2"></icon> &nbsp; Enter your card details</h5>
                    </div>
                    <div class="col-md-12 activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="mobile" scale="2"></icon> &nbsp; تحقق من رقم الجوال</h5>
                        <h5 v-else><icon name="mobile" scale="2"></icon> &nbsp; Verify your mobile number</h5>
                    </div>

                </div>
                <div class="row shadows">
                    <div class="col" style="background-color: white; border: solid 1px darkgrey;"  v-if="stepNo == 2">

                        <form @submit.prevent="verifyCode" class="signup-form">
                            <div class="input">

                                <h5 v-if="lang === 'ar'"><icon name="envelope" scale="4"></icon> <br/>الرجاء إدخال رمز التحقق</h5>
                                <h5 v-else><icon name="envelope" scale="4"></icon> <br/>Please enter one time verification OTP code</h5>
                                <input
                                        v-model="form.code"
                                        name="code"
                                        type="text"
                                        placeholder="OTP Code #"
                                        required
                                        id="code">
                                <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>
                            </div>

                            <div class="input">
                                <p v-if="lang === 'ar'"><br/><strong><span>الرجاء إدخال رقم التأكيد الذي تم إرساله على رقم الجوال {{form.mobile}}</span></strong>. </p>
                                <p v-else><br/><strong>We sent a text message to {{form.mobile}}. If you have not received the text message, please click Resend / Change No</strong>. </p>
                            </div>

                            <div class="row">
                                <div v-if="lang === 'ar'" class="col-md-6"><button type="button" class="buttony" @click="previous"><icon name="refresh" scale="1.5"></icon> &nbsp; إعادة إرسال الرمز / تغيير الجوال</button></div>
                                <div v-else class="col-md-6"><button type="button" class="buttony" @click="previous"><icon name="refresh" scale="1.5"></icon> &nbsp; Resend / Change No</button></div>
                                <div v-if="lang === 'ar'" class="col-md-6"><button type="submit" class="buttonx"><icon name="check" scale="1.5"></icon> &nbsp; التحقق من الرمز</button></div>
                                <div v-else class="col-md-6"><button type="submit" class="buttonx"><icon name="check" scale="1.5"></icon> &nbsp; Verify OTP</button></div>
                            </div>
                        </form>

                    </div>
                </div>
                <div class="row"  v-if="stepNo == 2">
                    <div class="col-md-12 inactiveTab">
                        <h5 v-if="lang === 'ar'"><icon name="user" scale="2"></icon> &nbsp; التفاصيل الشخصية والتسجيل</h5>
                        <h5  v-else><icon name="user" scale="2"></icon> &nbsp; Personal Details and Register</h5>
                    </div>
                </div>
            </div>

            <!--================================================================================================================-->
            <!--================================================================================================================-->
            <!--================================================================================================================-->

            <div class="container"  v-if="stepNo == 3">
                <div class="row">
                    <div class="col activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="credit-card" scale="2"></icon> &nbsp; أدخل تفاصيل البطاقة</h5>
                        <h5 v-else><icon name="credit-card" scale="2"></icon> &nbsp; Enter your card details</h5>
                    </div>
                    <div class="col-md-12 activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="mobile" scale="2"></icon> &nbsp; تحقق من رقم الجوال</h5>
                        <h5 v-else><icon name="mobile" scale="2"></icon> &nbsp; Verify your mobile number</h5>
                    </div>
                    <div class="col-md-12 activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="user" scale="2"></icon> &nbsp; التفاصيل الشخصية والتسجيل</h5>
                        <h5 v-else><icon name="user" scale="2"></icon> &nbsp; Personal Details and Register</h5>
                    </div>
                </div>
                <form @submit.prevent="signup">

                    <div class="row shadows">
                        <div class="col-md-12" style="background-color: white; border: solid 1px darkgrey;"  v-if="stepNo == 3">

                            <div class="signup-form" style="width:100% !important;">
                                <div class="input">
                                    <h5 v-if="lang === 'ar'"><icon name="user"></icon>&nbsp;الرجاء إدخال بياناتك الشخصية</h5>
                                    <h5 v-else><icon name="user"></icon>&nbsp; Please Enter Your Personal Details</h5>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="input">
                                            <input  required
                                                    v-model="form.lastName"
                                                    name="code"
                                                    type="text"
                                                    placeholder="Name - الاسم"
                                                    id="code">
                                            <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">

                                        <div class="input">
                                            <multiselect
                                                v-model="multiSelect.gender"
                                                @input="onSelectGender"
                                                :options="genders"
                                                placeholder="Select Gender - حدد نوع الجنس"
                                                label="name" track-by="id">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>

<!--                                <div class="row">-->
<!--                                    <div class="col-md-6">-->
<!--                                        <div class="input">-->
<!--                                            <date-picker-->
<!--                                                    v-model="dateSelect.leaveDateFrom"-->
<!--                                                    type="date"-->
<!--                                                    @change="onSelectBirthday"-->
<!--                                                    placeholder = "Date of Birth - تاريخ الولادة"-->
<!--                                                    format="dd-MM-yyyy"-->
<!--                                                    lang="en">-->
<!--                                            </date-picker>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="col-md-6">-->

<!--                                        <div class="input">-->
<!--                                            <input  required-->
<!--                                                    v-model="form.lastName"-->
<!--                                                    name="code"-->
<!--                                                    type="text"-->
<!--                                                    placeholder="Last Name - الاسم الاخير"-->
<!--                                                    id="code">-->
<!--                                            <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                    <div class="col-md-6">-->

<!--                                        <div class="input">-->
<!--                                            <input  required-->
<!--                                                    v-model="form.iqama"-->
<!--                                                    name="code"-->
<!--                                                    type="number"-->
<!--                                                    placeholder="Iqama or ID No# - الإقامة أو رقم الهوية"-->
<!--                                            >-->
<!--                                        </div>-->
<!--                                    </div>-->


<!--                                </div>-->
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="input">
                                            <multiselect
                                                    v-model="multiSelect.nationality"
                                                    @input="onSelectNationality"
                                                    :options="nationalities"
                                                    placeholder="Select Nationality - اختر الجنسية"
                                                    label="name" track-by="id">
                                            </multiselect>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="input">
                                            <multiselect
                                                v-model="multiSelect.marital"
                                                @input="onSelectMarital"
                                                :options="maritalStatuses"
                                                placeholder="Marital Status - اختر الحالة الاجتماعية"
                                                label="name" track-by="id">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">

                                    <div class="col-md-6">

                                        <div class="input">
                                            <multiselect
                                                    v-model="multiSelect.language"
                                                    @input="onSelectLanguage"
                                                    :options="languages"
                                                    placeholder="Preferred Language - اختر اللغة المفضلة"
                                                    label="name" track-by="id">
                                            </multiselect>
                                        </div>
                                    </div>

                                    <div class="col-md-6">

                                        <div class="input" v-if="form.countryCode == 966">
                                            <multiselect
                                                v-model="multiSelect.city"
                                                @input="onSelectCity"
                                                :options="citiesKSA"
                                                placeholder="Select City - اختر مدينة"
                                                label="name" track-by="id">
                                            </multiselect>
                                        </div>
                                        <div class="input" v-if="form.countryCode == 973">
                                            <multiselect
                                                v-model="multiSelect.city"
                                                @input="onSelectCity"
                                                :options="citiesBahrain"
                                                placeholder="Select City - اختر مدينة"
                                                label="name" track-by="id">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
<!--                                <div class="input">-->
<!--                                    <h5 v-if="lang === 'ar'"><br/><icon name="map"></icon>&nbsp; الرجاء إدخال عنوانك</h5>-->
<!--                                    <h5 v-else><br/><icon name="map"></icon>&nbsp; Please Enter Your Address</h5>-->
<!--                                </div>-->
<!--                                <div class="row">-->
<!--                                    <div class="col-md-6">-->
<!--                                        <div class="input">-->
<!--                                            <input  required-->
<!--                                                    v-model="form.street"-->
<!--                                                    name="code"-->
<!--                                                    type="text"-->
<!--                                                    placeholder="House / Street Name - اسم البيت / الشارع"-->
<!--                                                    id="code">-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="col-md-6">-->

<!--                                        <div class="input">-->
<!--                                            <multiselect-->
<!--                                                v-model="multiSelect.country"-->
<!--                                                @input="onSelectCountry"-->
<!--                                                :options="countries"-->
<!--                                                placeholder="Select Country - حدد الدولة"-->
<!--                                                label="name" track-by="id">-->
<!--                                            </multiselect>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="row">-->
<!--                                    <div class="col-md-6">-->
<!--                                        <div class="input">-->
<!--                                            <input  required-->
<!--                                                    v-model="form.postcode"-->
<!--                                                    name="code"-->
<!--                                                    type="number"-->
<!--                                                    placeholder="Postcode - الرمز البريدي"-->
<!--                                                    id="code">-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    -->
<!--                                </div>-->
                                <div class="input">
                                    <h5 v-if="lang === 'ar'"><br/><icon name="lock"></icon>&nbsp; تفاصيل تسجيل الدخول</h5>
                                    <h5 v-else><br/><icon name="lock"></icon>&nbsp; Please Enter Your Login Details</h5>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="input">

                                            <input  required
                                                    v-model="form.email"
                                                    name="code"
                                                    type="email"
                                                    placeholder="Email Address - عنوان بريد الكتروني"
                                                    id="code">
                                            <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="input">

                                            <input  required
                                                    v-model="form.password"
                                                    name="code"
                                                    type="password"
                                                    placeholder="Password - كلمه المرور"
                                                    id="code">
                                            <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="input">

                                            <input  required
                                                    v-model="form.password2"
                                                    name="code"
                                                    type="password"
                                                    placeholder="Confirm Password - تأكيد كلمة المرور"
                                                    id="code">
                                            <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('card')"></span>
                                        </div>
                                    </div>
                                </div>

                                <span><br/></span>

                                <div class="row" v-if="lang === 'ar'" style="font-size: 0.9em;" align="right">
                                    <span style="margin-top: 10px; width: 90%;">
                                تسجيلك يدل على موافقتك  <router-link to="/register" target="_blank">للشروط والأحكام </router-link>
                                    </span>
                                    <div style="width: 45px; float: right;"><input style="border: none; box-shadow: none;" class="input" type="checkbox" id="checkbox" v-model="form.terms"></div>
                                    <span><br/>&nbsp;</span>
                                </div>

                                <div class="row" v-else style="font-size: 0.9em">
                                    <br/>

                                    <div style="width: 45px;"><input style="border: none; box-shadow: none;" class="input" type="checkbox" id="checkbox" v-model="form.terms"></div>
                                    <span style="margin-top: 10px;">By signing up, you agree to our <router-link to="/terms" target="_blank">Terms & Conditions</router-link>. Existing users please <router-link to="/terms">Click Here</router-link> to login.</span>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="input">
                                            <button v-if="lang === 'ar'" type="button" class="buttony" @click="previous"><icon name="arrow-circle-left" scale="1.5"></icon> للرجوع</button>
                                            <button v-else type="button" class="buttony" @click="previous"><icon name="arrow-circle-left" scale="1.5"></icon> Back</button>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="input">
                                            <button v-if="lang === 'ar'" type="submit" class="buttonx"><icon name="check-circle" scale="1.5"></icon> تقديم التسجيل</button>
                                            <button v-else type="submit" class="buttonx" :disabled="loading"><icon name="check-circle" scale="1.5"></icon> Complete Sign Up</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </form>
            </div>

            <!--================================================================================================================-->
            <!--================================================================================================================-->
            <!--================================================================================================================-->

            <div class="container"  v-if="stepNo == 4">
                <div class="row">
                    <div class="col activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="credit-card" scale="2"></icon> &nbsp; أدخل تفاصيل البطاقة</h5>
                        <h5 v-else><icon name="credit-card" scale="2"></icon> &nbsp; Enter you card details</h5>
                    </div>
                    <div class="col-md-12 activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="mobile" scale="2"></icon> &nbsp; تحقق من رقم الجوال</h5>
                        <h5 v-else><icon name="mobile" scale="2"></icon> &nbsp; Verify your mobile number</h5>
                    </div>
                    <div class="col-md-12 activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="user" scale="2"></icon> &nbsp; التفاصيل الشخصية والتسجيل</h5>
                        <h5 v-else><icon name="user" scale="2"></icon> &nbsp; Personal Details and Register</h5>
                    </div>
                    <div class="col-md-12 activeTab">
                        <h5 v-if="lang === 'ar'"><icon name="check" scale="2"></icon> &nbsp; أكملت تسجيل</h5>
                        <h5 v-else><icon name="check" scale="2"></icon> &nbsp; Registration is Complete</h5>
                    </div>
                </div>

                <div class="row shadows">
                    <div class="col" style="background-color: white; border: solid 1px darkgrey;">
                        <div class="input">
                            <h1 align="center"><br/><icon name="check-circle" scale="8"></icon> &nbsp;</h1><br/>
                            <h2 v-if="lang === 'ar'" align="center">تهانينا! الحساب اقيم بنجاح</h2><br/>
                            <h2 v-if="lang === 'en'" align="center">Congratulations! Account Created Successfully</h2><br/>
                            <h4 v-if="lang === 'ar'" align="center">يرجى تسجيل الدخول إلى حسابك للتحقق من نقاط المكافآت الخاصة بك</h4><br/>
                            <h4 v-if="lang === 'en'" align="center">Please login to your account to see your reward points</h4><br/>
                        </div>
                        <div class="signup-form">
                            <a v-if="lang === 'ar'" :href="'http://system.alnokhbamarkets.com/card/'+cardNumber"> <button type="button" class="buttony"><icon name="credit-card" scale="1.5"></icon> &nbsp; تحميل البطاقة</button></a>
                            <a v-if="lang === 'en'" :href="'http://system.alnokhbamarkets.com/card/'+cardNumber"> <button type="button" class="buttony"><icon name="credit-card" scale="1.5"></icon> &nbsp; Download Card</button></a>

                            <router-link v-if="lang === 'ar'" to="/login"> <button type="button" class="buttonx"><icon name="lock" scale="1.5"></icon> &nbsp; تسجيل الدخول</button></router-link>
                            <router-link v-if="lang === 'en'" to="/login"> <button type="button" class="buttonx"><icon name="lock" scale="1.5"></icon> &nbsp; Login Now</button></router-link>
                            <br/><br/><br/>&nbsp;
                        </div>
                    </div>

                </div>


            </div>

        </div>
        <div class="col-md-12"><br/><br/>&nbsp;</div>

    </div>
</template>

<script>
  import {Form, Errors} from '@/components/validations/forms';
  import router from './../../router'

  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
    data () {
      return {
        loading: null,
        cardNumber: null,
        form: new Form({
            lang: this.lang,
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            password2: null,
            card: null,
            countryCode: null,
            mobile: null,
            code: null,
            birthday: null,
            gender: null,
            nationality: null,
            iqama: null,
            marital: null,
            language: null,
            street: null,
            city: null,
            postcode: null,
            country: null,
            terms: false,
        }),

          cities: this.$store.getters['environment/getCities'],
          citiesKSA: this.$store.getters['environment/getCitiesKSA'],
          citiesBahrain: this.$store.getters['environment/getCitiesBahrain'],
          countries: this.$store.getters['environment/getCountries'],
          countryCodes: this.$store.getters['environment/getCountryCodes'],
          nationalities: this.$store.getters['environment/getNationalities'],
          genders: this.$store.getters['environment/getGender'],
          maritalStatuses: this.$store.getters['environment/getMaritalStatus'],
          languages: this.$store.getters['environment/getLanguages'],
          stepNo: 1,

      }
    },

   computed: {
       mobilePlaceholder: function () {
           if(this.$store.getters['environment/getCountryMain'] === 1){
               this.form.countryCode = 966;
               this.onSelectCountryCodes({id:966,name: 'Saudi Arabia:    +966'});
               this.multiSelect.countryCode = {id: 966, name: 'Saudi Arabia:    +966'};
               this.onSelectCountry({id:1});

           }
           if(this.$store.getters['environment/getCountryMain'] === 19){
               this.form.countryCode = 973;
               this.multiSelect.countryCode =     {id: 973, name: 'Bahrain:    +973'};
               this.onSelectCountry({id:19});
               this.onSelectCountryCodes({id:973,name: 'Bahrain:    +973',});
           }
           // `this` points to the vm instance
           if(this.form.countryCode === 966){return '0567891234';}
           if(this.form.countryCode === 973){return '035123456';}
           return '0XXXXXXXX';
       }
   },

    methods: {

        previous(){
            this.stepNo = this.stepNo-1;
        },

        checkCard(){
            this.$store.dispatch('auth/validateCard', this.form)
                .then(response => {
                    // router.replace('/pending');
                    if(response.result == "register"){
                        this.stepNo = 3;
                        if(this.lang === 'ar'){this.$snotify.success('تم التحقق من رقم هاتفك المحمول.');}
                        else{this.$snotify.success('We have verified your mobile number.');}
                    } else{
                        this.stepNo = 2;
                        if(this.lang === 'ar'){this.$snotify.success('لقد أرسلنا لك رمز التحقق. يرجى التحقق من رسالتك النصية.');}
                    else{this.$snotify.success('We have sent you SMS. Please verify your mobile number.');}

                    }
                })
                .catch(error => {
                    this.form.onFail(error);
                    if(this.lang === 'ar'){this.$snotify.error('تفاصيل غير صالحة');}
                    else{this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);}
                });
        },

        verifyCode(){
            this.$store.dispatch('auth/validateOTP', this.form)
                .then(response => {
                    if(this.lang === 'ar'){this.$snotify.success('تم التحقق من رقم هاتفك المحمول.');}
                    else{this.$snotify.success('We have verified your mobile number.');}
                    // router.replace('/pending');
                    this.stepNo = 3;
                })
                .catch(error => {
                    this.form.onFail(error);
                    if(this.lang === 'ar'){this.$snotify.error('تفاصيل غير صالحة');}
                    else{this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);}
                });
        },

        onSelectGender(value){this.form.gender = value.id;},
        onSelectBirthday(value){this.form.birthday = this.$moment(value).format('YYYY-MM-DD');},
        onSelectNationality(value){this.form.nationality = value.id;},
        onSelectMarital(value){this.form.marital = value.id;},
        onSelectLanguage(value){this.form.language = value.id;},
        onSelectCity(value){this.form.city = value.id;},
        onSelectCountry(value){this.form.country = value.id;},
        onSelectCountryCodes(value){

            if(this.form.countryCode){this.form.countryCode = null;}
            if(value){this.form.countryCode = value.id;}

            // alert(this.$store.getters['environment/getCountryMain']);
            let countryMainx = {countryMain:1};
            if(value.id === 966){let countryMainx = {countryMain:1}; this.$store.dispatch('environment/setCountryMain', countryMainx);}
            if(value.id === 973){let countryMainx = {countryMain:19}; this.$store.dispatch('environment/setCountryMain', countryMainx);}
            // if(countryMainx){this.$store.dispatch('environment/setCountryMain', {countryMainx})}
            // alert(this.$store.getters['environment/getCountryMain']);

        },


        signup(){

            // if(!this.form.birthday){this.$snotify.error('Please fill in your birthday'); return}
            if(!this.form.gender){this.$snotify.error('Please fill in your gender'); return}
            if(!this.form.nationality){this.$snotify.error('Please fill in your nationality'); return}
            if(!this.form.marital){this.$snotify.error('Please fill in your marital status'); return}
            if(!this.form.language){this.$snotify.error('Please fill in your preferred language'); return}
            if(!this.form.city){this.$snotify.error('Please fill in your city'); return}
            if(this.form.password !== this.form.password2){this.$snotify.error('Passwords do not match ---- كلمة المرور غير مطابقة'); return}
            if(this.form.terms === false){this.$snotify.error('Please accept our Terms ---- يرجى قبول الشروط والأحكام'); return}
            // if(!this.form.country){this.$snotify.error('Please fill in your country'); return}

            if(this.form.gender && this.form.nationality && this.form.marital && this.form.language && this.form.city){
                this.loading = 'disabled';
                this.$store.dispatch('auth/signup', this.form)
                    .then(response => {
                        this.$snotify.success('Congratulations. Your account has been registered.');
                        // router.replace('/pending');
                        this.cardNumber = response;
                        this.stepNo = 4;
                        this.loading = false;
                    })
                    .catch(error => {
                        this.form.onFail(error);
                        this.loading = null;
                        this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
                    });
            }


        },

        loadData(){
            this.$store.dispatch('environment/fetchCities')
                .then(response => {this.cities = this.$store.getters['environment/getCities'];})
            this.$store.dispatch('environment/fetchCitiesKSA')
                .then(response => {this.citiesKSA = this.$store.getters['environment/getCitiesKSA'];})
            this.$store.dispatch('environment/fetchCitiesBahrain')
                .then(response => {this.citiesBahrain = this.$store.getters['environment/getCitiesBahrain'];})

            this.$store.dispatch('environment/fetchCountries')
                .then(response => {this.countries = this.$store.getters['environment/getCountries'];})

            this.$store.dispatch('environment/fetchNationalities')
                .then(response => {this.nationalities = this.$store.getters['environment/getNationalities'];})

        },

    },

      created() {
          this.loadData();
      },
  }
</script>

<style scoped>
    .signup-form {
        max-width: 700px;
        text-align: center;
        margin: 20px auto;
    }
    .signup-form input,
    .signup-form textarea {
        border: solid 1px grey;
        outline: 0;
        padding: 2em;
        -moz-border-radius: 8px;
        -webkit-border-radius: 8px;
        border-radius: 8px;
        display: block;
        width: 100%;
        margin-top: 1em;
        font-family: "Merriweather", sans-serif;
        -moz-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        resize: none;
    }
    .signup-form input:focus,
    .signup-form textarea:focus {
        -moz-box-shadow: 0 0px 2px #e74c3c !important;
        -webkit-box-shadow: 0 0px 2px #e74c3c !important;
        box-shadow: 0 0px 2px #e74c3c !important;
    }
    .signup-form #input-submit {
        color: white;
        background: #e74c3c;
        cursor: pointer;
    }
    .signup-form #input-submit:hover {
        -moz-box-shadow: 0 3px 3px 3px rgba(170, 170, 170, 0.6);
        -webkit-box-shadow: 0 3px 3px 3px rgba(170, 170, 170, 0.6);
        box-shadow: 0 3px 3px 3px rgba(170, 170, 170, 0.6);
    }
    .signup-form textarea {
        height: 252px;
    }
    .shadows{
        -moz-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    }
    .signup-form button{
        border: solid 1px grey;
        outline: 0;
        padding: 1em;
        -moz-border-radius: 8px;
        -webkit-border-radius: 8px;
        border-radius: 8px;
        display: block;
        width: 100%;
        margin-top: 1em;
        font-family: "Merriweather", sans-serif;
        -moz-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
        resize: none;
        color: white;
        background: #009d0b;
        cursor: pointer;
        font-size: 16px;
    }
    .buttonx{
        color: white !important;
        background: #009d0b !important;
    }
    .buttony{
        color: white !important;
        background: #e74c3c !important;
    }


    .activeTab{
        background-color: #D04A58; border: solid 1px darkgrey; height: 70px; text-align: center; padding-top: 20px; color: white; margin-bottom: 10px;
    }
    .inactiveTab{
        background-color: #afafaf; color: white; border: solid 1px darkgrey; height: 70px; text-align: center; padding-top: 20px; color: white; margin-bottom: 10px;
    }
</style>
<style>
    .multiselect__tags{
        min-height: 90px !important;
        padding-top: 35px !important;;
        margin-top: 16px !important;;
        border: solid 1px gray !important;;
    }
    .multiselect__select{
        margin-top: 30px !important;;
    }
    .mx-input{
        height: 90px !important;
        margin-top: 17px !important;
        padding-left: 25px !important;
        border: solid 1px gray !important;
    }
    .mx-datepicker{
        width: 100% !important;
    }
    .mx-input-icon__calendar{
        margin-top: 10px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/login/register.vue